var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"stroke":"currentColor","fill":"currentColor","stroke-width":"0","viewBox":"0 0 20 20","aria-hidden":"true","height":"1em","width":"1em","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }